import React, { useMemo } from 'react';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { convertTimeStampToDate } from '../../../common/utils/dateUtils';
import showAlert from '../../../common/utils/alert';
import { Link } from 'react-router-dom';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export const CustomFunctionTable = ({
  projectId,
  version,
  actions,
  flag,
  customFunctions,
  isReadOnly,
}) => {
  console.log('This is the version in the custom function that is being passed: ', version);
  console.log(
    'This is the typeof version in the custom function that is being passed: ',
    typeof version,
  );
  const handleDelete = (uuid) => {
    const preConfirm = async () => {
      try {
        await actions.deleteCustomFunction({ projectId, uuid, version });
        await Swal.fire('Deleted!', 'Function has been deleted.', 'success');
      } catch (error) {
        console.error('Error deleting function:', error);
        await Swal.fire('Error', 'Failed to delete function.', 'error');
      }
    };

    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };
  const handleClone = (customFunction) => {
    console.log('actions in my clone function', actions);
    const preConfirm = async () => {
      version = Number(version);
      const args = { projectId, customFunction, version };
      try {
        await actions.cloneCustomFunction(args);
        toast.success('cloned Successfully!');
      } catch (error) {
        console.error('Error deleting function:', error);
        const errMsg = getErrorMessageFromResponse(error);
        toast.error(`Failed: ${errMsg}` || 'Failed to Clone !');
      }
    };
    showAlert(
      `Do you want to clone ${customFunction.name} CustomFunction ?`,
      preConfirm,
      'Yes, clone it!',
    );
  };
  const componentRows = useMemo(() => {
    if (!Array.isArray(customFunctions)) return null;

    if (customFunctions.length) {
      return customFunctions.map((customFunction) => (
        <tr key={customFunction.uuid} className="text-left td-align-middle">
          <td>{customFunction.name}</td>
          <td>{convertTimeStampToDate(customFunction.createdAt)}</td>
          <td className="text-right">
            &nbsp;
            <Link
              className="btn btn-xs btn-primary"
              title={`Edit ${customFunction.name}`}
              to={{
                pathname: `/custom-component/${version}/v/${projectId}/customFunction/edit/${customFunction.uuid}`,
              }}
            >
              <i className="wb webconnect-pencil"></i>
            </Link>
            <Link
              className="btn btn-xs btn-theme-green"
              title={`Logs ${customFunction.name}`}
              to={{
                pathname: `/custom-component/${version}/v/${projectId}/customFunction/logs/${customFunction.uuid}`,
              }}
            >
              <i className="wb webconnect-file-text"></i>
            </Link>
            <button
              className="btn btn-xs btn-theme-submit"
              onClick={() => (isReadOnly ? null : handleClone(customFunction))}
              title={isReadOnly ? 'Read-Only Mode' : `Clone ${customFunction.name}`}
              disabled={isReadOnly}
            >
              <i className="wb webconnect-clone"></i>
            </button>
            <button
              className={`btn btn-xs btn-theme-delete`}
              onClick={() => (flag && !isReadOnly ? handleDelete(customFunction.uuid) : undefined)}
              title={isReadOnly ? 'Read-Only Mode' : `Delete ${customFunction.name}`}
              style={{ cursor: flag && !isReadOnly ? 'pointer' : 'not-allowed' }}
              disabled={isReadOnly}
            >
              <i className="wb webconnect-trash-solid"></i>
              {!flag && (
                <>
                  &nbsp;
                  <TooltipInfo
                    title={description}
                    headerText={`Permission Disabled!`}
                    showHeader={true}
                    showArrow={true}
                  />
                </>
              )}
            </button>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr>
          <td colSpan="3" className="align-middle text-center">
            No Custom Function!
          </td>
        </tr>
      );
    }
  }, [customFunctions, flag, projectId, version, actions]);

  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <ParentCardNoCol
        title="Custom Function"
        icon="customFunction"
        bgColor="drapcode-violet"
        CtaComponent={
          <Link
            className={`btn btn-theme-submit btn-md ${isReadOnly ? 'disabled' : ''}`}
            title={isReadOnly ? 'Read-Only Mode' : 'Create Custom Function'}
            to={{
              pathname: isReadOnly
                ? '#'
                : `/custom-component/${version}/v/${projectId}/customFunction/create`,
            }}
            onClick={(e) => {
              if (isReadOnly) {
                e.preventDefault();
              }
            }}
          >
            <i className={`wb ${drapcodeIcon('add')}`}></i> &nbsp;Create Custom Function
          </Link>
        }
      >
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-sm table-word-break connector-list">
            <thead>
              <tr>
                <th>Name</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>{componentRows}</tbody>
          </table>
        </div>
      </ParentCardNoCol>
    </div>
  );
};
